// extracted by mini-css-extract-plugin
module.exports = {"stacks":"stacks-module--stacks--2eMhn","stacks__item":"stacks-module--stacks__item--tHi8_"};